import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Paper,
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import { Chatbot } from '../../types/chatbot';

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  chatbotToDelete: Chatbot | null;
  confirmationName: string;
  onConfirmationNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onConfirmDelete: () => Promise<void>;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  onClose,
  chatbotToDelete,
  confirmationName,
  onConfirmationNameChange,
  onConfirmDelete,
}) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Chatbot</DialogTitle>
      <DialogContent>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 2, 
            bgcolor: theme.palette.mode === 'dark' ? 'background.default' : '#fff9f9',
            borderRadius: 1,
            border: '1px solid',
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 0, 0, 0.2)' : theme.palette.error.light
          }}
        >
          <Typography variant="body1" color="error">
            Are you sure you want to delete the chatbot "{chatbotToDelete?.name}"? This action cannot be undone.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2">
              To confirm, please type the chatbot name exactly as shown above:
            </Typography>
            <TextField
              fullWidth
              value={confirmationName}
              onChange={onConfirmationNameChange}
              margin="normal"
              placeholder="Type chatbot name here"
              size="small"
            />
          </Box>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onConfirmDelete}
          color="error"
          disabled={confirmationName !== chatbotToDelete?.name}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog; 